import { Component, ElementRef, HostListener, viewChild } from '@angular/core';
import { isElementVisibleInContainer } from '../../utils/utils';
import { FocusManagerService } from '../focus-manager.service';
import { BaseElementComponent } from '../base-element/base-element.component';
import { contains } from '@progress/kendo-angular-common';

@Component({
  selector: 'base-list',
  template: '<ng-content></ng-content>',
  styles: ''
})
export class BaseListComponent {


  constructor(public elementRef: ElementRef<HTMLElement>, public focusManager: FocusManagerService) { }

  public getChildren(): readonly BaseElementComponent[] {
    return [];
  }
  private selectedChildIdx = -1;

  public keyProperty = "base-list";

  @HostListener('document:keydown', ['$event'])
  onKeyDown2(e: Event) {
    let keyEv = e as KeyboardEvent;
    let contains = this.elementRef.nativeElement.contains(keyEv.target as any);
    if (!contains && this.isEditing) {
      console.log("Focus lost");
      this.focusInside();
    }

  }

  // @HostListener('document:keydown', ['$event'])
  onKeyDown(e: Event) {
    let keyEv = e as KeyboardEvent;
    if (this.focusManager.getFocusArea() == this.keyProperty) {
      let childrenElements = this.getChildren();
      let prevIdx = this.selectedChildIdx;

      if (keyEv.key == "ArrowDown") {
        if (this.selectedChildIdx < childrenElements.length - 1) {
          this.selectedChildIdx++;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
      } else if (keyEv.key == "ArrowUp") {
        if (this.selectedChildIdx > 0) {
          this.selectedChildIdx--;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
      } else if (keyEv.key == "Enter") {
        if (this.selectedChildIdx >= 0) {
          let childElement = childrenElements[this.selectedChildIdx];
          if (childElement != undefined) {
            childElement.open();
          }
        }
      } else if (keyEv.key == "Escape") {
        this.close();
        return;
      }
      if (prevIdx != this.selectedChildIdx) {
        if (prevIdx >= 0) {
          let childElement = childrenElements[prevIdx];
          childElement.showFocus = false;
        }
        if (this.selectedChildIdx >= 0) {
          let aiEditor = childrenElements[this.selectedChildIdx];
          if (aiEditor != undefined) {
            aiEditor.showFocus = true;
            let parent = aiEditor.elementRef.nativeElement.parentElement;//this.container()?.nativeElement;//.parentElement;
            if (parent && !isElementVisibleInContainer(aiEditor.elementRef.nativeElement, parent)) {
              aiEditor.elementRef.nativeElement.scrollIntoView({ block: 'nearest', inline: 'nearest' });
              let parentElement = aiEditor.elementRef.nativeElement.parentElement;
              if (parentElement != undefined && parentElement.className.indexOf("element-container") >= 0) {
                parentElement.scrollIntoView({ block: 'nearest', inline: 'nearest' });
              }
            }
          }

        }

      }
    }
  }


  // public container = viewChild<ElementRef<HTMLDivElement>>('container');
  public isEditing: boolean = false;

  private focusInside() {
    let childrenElements = this.getChildren();
    let firstChild = childrenElements[0];
    if (firstChild != undefined) {
      let parentElement = firstChild.elementRef.nativeElement.parentElement;

      if (parentElement != undefined && parentElement.className.indexOf("element-container") >= 0) {
        parentElement.tabIndex = 0;
        parentElement.focus();
      } else {
        firstChild.elementRef.nativeElement.tabIndex = 0;
        firstChild.elementRef.nativeElement.focus();
      }
    }

  }

  open() {
    this.isEditing = true;
    this.focusManager.pushFocus(this.keyProperty);
    this.elementRef.nativeElement.onkeydown = (e: Event) => {
      this.onKeyDown(e);
    }
    setTimeout(() => {
      this.focusInside();
    }, 100);
  }

  close() {

    this.isEditing = false;
    this.focusManager.popFocus(this.keyProperty);
    this.elementRef.nativeElement.onkeydown = null;
  }

}
